import widowStore from '../store/windowStore';

export default class {
    constructor() {

    }

    init() {

    }

}
